import z from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema, ObjectIdString } from '../common.js';

export const USER_MEMORY_MAX_ENTRIES = 30;
export const USER_MEMORY_MAX_CONTENT_LENGTH = 300;

// One durable fact the LLM saved about a user; _id is minted at the write path (like chat messages), timestamps are stored for future staleness handling but unread today
export const UserMemoryEntry = z.object({
  _id: ObjectIdSchema,
  content: z.string().max(USER_MEMORY_MAX_CONTENT_LENGTH),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type UserMemoryEntry = z.infer<typeof UserMemoryEntry>;

// The full entry with its id as a string
export const UserMemoryEntryDTO = UserMemoryEntry.omit({ _id: true }).safeExtend({
  id: ObjectIdString,
});
export type UserMemoryEntryDTO = z.infer<typeof UserMemoryEntryDTO>;

// The minimal entry, just the id and the stored text
// TODO(#2436): consider dropping this in favor of UserMemoryEntryDTO everywhere
export const UserMemoryEntryView = z.object({ id: z.string(), content: z.string() });
export type UserMemoryEntryView = z.infer<typeof UserMemoryEntryView>;

// Per-user (AuthUser) Ask Toro memory — one doc per user, cap enforced by applyUserMemoryOperation's query filter
export const IUserMemory = z.object({
  _id: ObjectIdSchema,
  account: objectIdRef('Account'),
  user: objectIdRef('AuthUser'),
  entries: UserMemoryEntry.array().default([]),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IUserMemory = z.infer<typeof IUserMemory>;
